import { SnowplowService } from 'wanderu-service-analytics';

function dateClicked({ date, price, index }) {
    SnowplowService.fireStructuredEvent({
        category: price
            ? 'c2c_price_grid'
            : 'c2c_time_table',
        label: price
            ? 'price_ribbon'
            : 'time_table_date_picker',
        action: 'click',
        property: JSON.stringify({
            date,
            price,
            date_index: index,
        }),
    });
}

export default { dateClicked };
